import ProductionDataOptions from './ProductionDataOptions'
import SubMenu from './SubMenu'

const ProductionData = () => (
    <SubMenu componentOptions={ProductionDataOptions} />
)

export default ProductionData